import { API_BASE } from '../config/vars';
import { call } from './http';


const formatAreaContextBody = (areaContext, recordingId) => {
  return JSON.stringify({
    type: areaContext.type,
    areaId: areaContext.areaId,
    taxonomy: areaContext.taxonomy,
    recording: recordingId
  });
};

const formatLineContextBody = (lineContext, recordingId) => {
  return JSON.stringify({
    type: lineContext.type,
    actions: lineContext.actions,
    withinLocationMovementKey: lineContext.withinLocationMovementKey,
    recording: recordingId,
    metadata: lineContext.metadata
  });
};

export const areaContext = {
  create: (newAreaContext, recordingId) => {
    const body = formatAreaContextBody(newAreaContext, recordingId);
    return call({
      path: `${API_BASE}/v1/areaContext/create`,
      fetchOptions: { method: 'POST', body }
    });
  },
  update: (updatedAreaContext, recordingId) => {
    const body = formatAreaContextBody(updatedAreaContext, recordingId);
    return call({
      path: `${API_BASE}/v1/areaContext/${updatedAreaContext.id}/update`,
      fetchOptions: { method: 'POST', body }
    });
  },
  delete: (deletedAreaContextId) =>
    call({
      path: `${API_BASE}/v1/areaContext/${deletedAreaContextId}/delete`,
      fetchOptions: { method: 'DELETE' },
      responseExpected: false
    })
};

export const lineContext = {
  create: (newLineContext, recordingId) => {
    const body = formatLineContextBody(newLineContext, recordingId);
    return call({
      path: `${API_BASE}/v1/lineContext/create`,
      fetchOptions: { method: 'POST', body }
    });
  },
  update: (updatedLineContext, recordingId) => {
    const body = formatLineContextBody(updatedLineContext, recordingId);
    if (!updatedLineContext.id) {
      return null;
    }
    return call({
      path: `${API_BASE}/v1/lineContext/${updatedLineContext.id}/update`,
      fetchOptions: { method: 'POST', body }
    });
  },
  delete: (deletedAreaContextId) =>
    call({
      path: `${API_BASE}/v1/lineContext/${deletedAreaContextId}/delete`,
      fetchOptions: { method: 'DELETE' },
      responseExpected: false
    })
};

export const recordings = {
  get: (recId, options) => {
    return call({
      path: `${API_BASE}/v1/recording/${recId}?` + (options? new URLSearchParams(options).toString() : ""),
      fetchOptions: { method: 'GET' }
    })
  },
  list: (options) => {
    return call({
      path: `${API_BASE}/v1/recording/list`,
      fetchOptions: { method: 'POST', body: JSON.stringify(options || {}) }
    })
  },
  create: (options) => {
    return call({
      path: `${API_BASE}/v1/recording`,
      fetchOptions: { method: 'POST', body: JSON.stringify(options) },
    })
  },
  update: (recId, options) => {
    return call({
      path: `${API_BASE}/v1/recording/${recId}`,
      fetchOptions: { method: 'PATCH', body: JSON.stringify(options || {}) }
    })
  },
  thumbnail: {
    patch: (recId, options) => {
      return call({
          path: `${API_BASE}/v1/recording/${recId}/thumbnail`,
          fetchOptions: { method: 'PATCH', body: JSON.stringify(options || {}) }
        })
      }
    }
};

export const processingConfig = {
  get: (recId) =>
    call({
      path: `${API_BASE}/v1/recording/${recId}/processingConfig`,
      fetchOptions: { method: 'GET' }
    }),
  create: (recording, config) =>
    call({
      path: `${API_BASE}/v1/processingConfig/create`,
      fetchOptions: { method: 'POST', body: JSON.stringify({ recording, config }) }
    }),
  update: (recording, config) =>
    call({
      path: `${API_BASE}/v1/processingConfig/create`,
      fetchOptions: { method: 'POST', body: JSON.stringify({ recording, config }) }
    }),
};

export const cameraServers = {
  list: (options) => {
    return call({
      path: `${API_BASE}/v1/cameraServer/list`,
      fetchOptions: { method: 'POST', body: JSON.stringify(options || {}) }
    })
  },
  get: (deviceId, options) => {
    return call({
      path: `${API_BASE}/v1/cameraServer/${deviceId}?` + (options? new URLSearchParams(options).toString() : ""),
      fetchOptions: { method: 'GET' }
    })
  },
  update: (deviceId, options) => {
    return call({
      path: `${API_BASE}/v1/cameraServer/${deviceId}/update`,
      fetchOptions: { method: 'PATCH', body: JSON.stringify(options || {}) }
    })
  }
};

export const organisations = {
  list: () => {
    return call({
      path: `${API_BASE}/v1/organisation`,
      fetchOptions: { method: 'GET' }
    })
  },
  create: (options) => {
    return call({
      path: `${API_BASE}/v1/organisation`,
      fetchOptions: { method: 'POST', body: JSON.stringify(options || {}) }
    })
  },
  get: ( organisationId ) => {
    return call({
      path: `${API_BASE}/v1/organisation/${organisationId}`,
      fetchOptions: { method: 'GET' }
    })
  },
  update: ( organisationId, options ) => {
    return call({
      path: `${API_BASE}/v1/organisation/${organisationId}`,
      fetchOptions: { method: 'PATCH', body: JSON.stringify(options || {}) }
    })
  },
  userHasMembership: () => {
    return call({
      path: `${API_BASE}/v1/organisation/userHasMembership`,
      fetchOptions: {method: 'GET'},
    })
  },
  availableMetrics: {
    get: (organisationId) => {
      return call({
        path: `${API_BASE}/v1/organisation/${organisationId}/availableMetrics`,
        fetchOptions: { method: 'GET' }
      })
    },
    update: (organisationId, config) => {
      return call({
        path: `${API_BASE}/v1/organisation/${organisationId}/availableMetrics`,
        fetchOptions: { method: 'PUT', body: JSON.stringify({config}) }
      })
    }
  }
};

export const locations = {
  list: (options) => {
    return call({
      path: `${API_BASE}/v1/location/list`,
      fetchOptions: { method: 'POST', body: JSON.stringify(options || {}) }
    })
  },
  get: (locationId, options) => {
    return call({
      path: `${API_BASE}/v1/location/${locationId}?` + (options? new URLSearchParams(options).toString() : ""),
      fetchOptions: { method: 'GET' }
    })
  },
  create: (options) => {
    return call({
      path: `${API_BASE}/v1/location`,
      fetchOptions: { method: 'POST', body: JSON.stringify(options || {}) }
    })
  },
  update: (locationId, options) => {
    return call({
      path: `${API_BASE}/v1/location/${locationId}`,
      fetchOptions: { method: 'PATCH', body: JSON.stringify(options || {}) }
    })
  },
  assignTag: (locationId, tagId, otherOptions) => {
    return call({
      path: `${API_BASE}/v1/location/${locationId}/tag/${tagId}`,
      fetchOptions: { method: 'PUT' },
      otherOptions
    })
  },
  unassignTag: (locationId, tagId, otherOptions) => {
    return call({
      path: `${API_BASE}/v1/location/${locationId}/tag/${tagId}`,
      fetchOptions: { method: 'DELETE' },
      otherOptions
    })
  }
};

export const entityTags = {
  list: (options) => {
    return call({
      path: `${API_BASE}/v1/tags?` + (options? new URLSearchParams(options).toString() : ""),
      fetchOptions: { method: 'GET' }
    })
  },
  create: (options, otherOptions) => {
    return call({
      path: `${API_BASE}/v1/tags`,
      fetchOptions: { method: 'POST', body: JSON.stringify(options || {}) },
      otherOptions
    })
  }
};

export const statElems = {
  create: (recording, config) =>
    call({
      path: `${API_BASE}/v1/statElems/create`,
      fetchOptions: {
        method: 'POST',
        body: JSON.stringify({ recording, config })
      }
    })
};

export const dashboardReports = {
  list: () => {
    return call({
      path: `${API_BASE}/v1/dashboard-report/list`,
      fetchOptions: { method: 'GET' }
    })
  },
};

export const scheduledReportJobs = {
  list: () => {
    return call({
      path: `${API_BASE}/v1/scheduled-report-job/list`,
      fetchOptions: { method: 'GET' }
    })
  },
  create: (payload) => {
    return call({
      path: `${API_BASE}/v1/scheduled-report-job`,
      fetchOptions: { method: 'POST', body: JSON.stringify(payload) }
    })
  },
  update: (id, payload) => {
    return call({
      path: `${API_BASE}/v1/scheduled-report-job/${id}`,
      fetchOptions: { method: 'PUT', body: JSON.stringify(payload) }
    })
  },
  remove: (id) => {
    return call({
      path: `${API_BASE}/v1/scheduled-report-job/${id}`,
      fetchOptions: { method: 'DELETE' },
      responseExpected: false
    })
  },
};

export const users = {
  profile: () => {
    return call({
      path: `${API_BASE}/v1/users/profile`,
      fetchOptions: { method: 'GET' },
    })
  }
};
